import JsonPars from '@UI/JsonPars/JsonPars'
import s from './index.module.css'
import common from '../../common.module.css'
import classNames from 'classnames'
import { getCorrectFilePath } from "@/helpers/new/getCorrectFilePath";

export const Options = (
    {
        optionsText,
        optionsImg,
        dragOvertHandler = () => {},
        dropHandler = () => {},
        dragEndHandler = () => {},
        removeFromCart = () => {},
        setCuttentOptionByClick = () => {},
        cuttentOptionByClick = null,
        dragStartHandler = () => {},
        isInteractive = false
    }
) => {
    return(
        <div 
            {
                ...(isInteractive && {
                    onDragOver: dragOvertHandler, //находимся над ним
                    onDrop: (e) => dropHandler(e, 'none'), //отпустили карточку и рассчитываем что должно произойти какое то связанное с этим действие
                    onDragLeave: (e) => dragEndHandler(e), //вышли за перделы другой карточки
                    onClick:
                        (e)=>{
                            if(!e.target.classList.contains(s.option)){
                                removeFromCart()
                            }
                        }
                })
            }
            
            className={s.optionsWrapper}
        >
            <div className={common.title}>Распредели слова по группам</div>
            <div className={common.options}>
                {
                    optionsText.map((option) => {
                        return (
                            <button 
                                key={option.id}
                                {
                                    ...(isInteractive && {
                                        onClick: (e) => {
                                            setCuttentOptionByClick(option)
                                        },
                                        onDragStart: (e) => dragStartHandler(e, option, 'none'), //взяли карточку
                                        onDragEnd: dragEndHandler, //отпустили перемещение картички
                                    })
                                } 
                                draggable={isInteractive} //сделали передвигаемой
                                style={{ whiteSpace: 'pre-line'}}
                                className={classNames(s.option, {[common.optionCurrent]: cuttentOptionByClick && cuttentOptionByClick.id == option.id} )}>
                                <JsonPars json={option.text} />
                            </button>
                        )
                    })
                }

                <div style={{width:'100%', height:'1px', background: 'none'}}></div>

                {
                    optionsImg.map((option) => {
                        return (
                        <button 
                            key={option.id}
                            {
                                ...(isInteractive && {
                                    onClick: (e) => setCuttentOptionByClick(option),
                                    onDragStart: (e) => dragStartHandler(e, option, 'none'), //взяли карточку
                                    onDragEnd: dragEndHandler, //отпустили перемещение картички
                                })   
                            }
                            draggable={isInteractive} //сделали передвигаемой
                            style={{ whiteSpace: 'pre-line'}}
                            className={classNames(s.option, common.optionImg, {[common.optionCurrent]: cuttentOptionByClick && cuttentOptionByClick.id == option.id} )}>
                            <img alt='Изображение' src={getCorrectFilePath(option?.img)} />
                        </button>
                        )
                    })
                }
            </div>
        </div>
    )
}